import { CommonEnums } from '../../common.enums';

export class TEmail_Inst {
    tEmail_Inst_Id: number;
    nm: string;
    description: string;
    ver: string;
    email_From: string;
    email_To: string;
    email_Cc: string;
    subject: string;
    message: string;
    createDt: Date;
    updateBy: string;
    updateDt: Date;
    agentGrpInd: string;
    flagent_Id: number;
    valid_Cd: string;
    dxFlow_Id: number;
    disableFlg: string;
    attachmentFiles: string;
    flagentNm: string;
    msgValid_Cd: string;
    email_To_Valid_Cd: string;
    email_Cc_Valid_Cd: string;
    subject_Valid_Cd: string;
    retryEnabled: string;
    numOfRetryAttempts: number;
    retryWaitTime: number;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.tEmail_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.email_From = CommonEnums.defaults.STRING_EMPTY;
        this.email_To = CommonEnums.defaults.STRING_EMPTY;
        this.email_Cc = CommonEnums.defaults.STRING_EMPTY;
        this.subject = CommonEnums.defaults.STRING_EMPTY;
        this.message = CommonEnums.defaults.STRING_EMPTY;
        this.createDt = new Date();
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.agentGrpInd = CommonEnums.defaults.STRING_EMPTY;
        this.flagent_Id = CommonEnums.defaults.LONG_VAL;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.disableFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.attachmentFiles = CommonEnums.defaults.STRING_EMPTY;
        this.flagentNm = CommonEnums.defaults.STRING_EMPTY;
        this.msgValid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.email_To_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.email_Cc_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.email_Cc_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.email_Cc_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.retryEnabled = CommonEnums.defaults.STRING_EMPTY;
        this.numOfRetryAttempts = 2;
        this.retryWaitTime = 60;
    }

    copy(): TEmail_Inst {
        let tEmail_InstTmp: TEmail_Inst = new TEmail_Inst();

        tEmail_InstTmp.tEmail_Inst_Id = this.tEmail_Inst_Id;
        tEmail_InstTmp.nm = this.nm;
        tEmail_InstTmp.description = this.description;
        tEmail_InstTmp.ver = this.ver;
        tEmail_InstTmp.email_From = this.email_From;
        tEmail_InstTmp.email_To = this.email_To;
        tEmail_InstTmp.email_Cc = this.email_Cc;
        tEmail_InstTmp.subject = this.subject;
        tEmail_InstTmp.message = this.message;
        tEmail_InstTmp.createDt = this.createDt;
        tEmail_InstTmp.updateBy = this.updateBy;
        tEmail_InstTmp.updateDt = this.updateDt;
        tEmail_InstTmp.agentGrpInd = this.agentGrpInd;
        tEmail_InstTmp.flagent_Id = this.flagent_Id;
        tEmail_InstTmp.valid_Cd = this.valid_Cd;
        tEmail_InstTmp.dxFlow_Id = this.dxFlow_Id;
        tEmail_InstTmp.disableFlg = this.disableFlg;
        tEmail_InstTmp.attachmentFiles = this.attachmentFiles;
        tEmail_InstTmp.flagentNm = this.flagentNm;
        tEmail_InstTmp.msgValid_Cd = this.msgValid_Cd;
        tEmail_InstTmp.email_To_Valid_Cd = this.email_To_Valid_Cd;
        tEmail_InstTmp.email_Cc_Valid_Cd = this.email_Cc_Valid_Cd;
        tEmail_InstTmp.subject_Valid_Cd = this.subject_Valid_Cd;
        tEmail_InstTmp.retryEnabled = this.retryEnabled;
        tEmail_InstTmp.numOfRetryAttempts = this.numOfRetryAttempts;
        tEmail_InstTmp.retryWaitTime = this.retryWaitTime;

        return tEmail_InstTmp;
    }

    copyFrom(tEmail_InstTmp: TEmail_Inst): void {
        this.tEmail_Inst_Id = tEmail_InstTmp.tEmail_Inst_Id;
        this.nm = tEmail_InstTmp.nm;
        this.description = tEmail_InstTmp.description;
        this.ver = tEmail_InstTmp.ver;
        this.email_From = tEmail_InstTmp.email_From;
        this.email_To = tEmail_InstTmp.email_To;
        this.email_Cc = tEmail_InstTmp.email_Cc;
        this.subject = tEmail_InstTmp.subject;
        this.message = tEmail_InstTmp.message;
        this.createDt = tEmail_InstTmp.createDt;
        this.updateBy = tEmail_InstTmp.updateBy;
        this.updateDt = tEmail_InstTmp.updateDt;
        this.agentGrpInd = tEmail_InstTmp.agentGrpInd;
        this.flagent_Id = tEmail_InstTmp.flagent_Id;
        this.valid_Cd = tEmail_InstTmp.valid_Cd;
        this.dxFlow_Id = tEmail_InstTmp.dxFlow_Id;
        this.disableFlg = tEmail_InstTmp.disableFlg;
        this.attachmentFiles = tEmail_InstTmp.attachmentFiles;
        this.flagentNm = tEmail_InstTmp.flagentNm;
        this.msgValid_Cd = tEmail_InstTmp.msgValid_Cd;
        this.email_To_Valid_Cd = tEmail_InstTmp.email_To_Valid_Cd;
        this.email_Cc_Valid_Cd = tEmail_InstTmp.email_Cc_Valid_Cd;
        this.subject_Valid_Cd = tEmail_InstTmp.subject_Valid_Cd;
        this.retryEnabled = tEmail_InstTmp.retryEnabled;
        this.numOfRetryAttempts = tEmail_InstTmp.numOfRetryAttempts;
        this.retryWaitTime = tEmail_InstTmp.retryWaitTime;
    }

    compare(tEmail_InstTmp: TEmail_Inst): string {
        let tEmail_InstString: string =this.toString(false);
        let tEmail_InstTmpString: string = tEmail_InstTmp.toString(false);

        if (tEmail_InstString != tEmail_InstTmpString) {
            return tEmail_InstString + ', ' + tEmail_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "TEmail_Inst [tEmail_Inst_Id=" + this.tEmail_Inst_Id +
            ", nm=" + this.nm +
            ", description=" + this.description +
            ", ver=" + this.ver +
            ", email_From=" + this.email_From +
            ", email_To=" + this.email_To +
            ", email_Cc=" + this.email_Cc +
            ", subject=" + this.subject +
            ", message=" + this.message +
            ", createDt=" + this.createDt +
            ", updateBy=" + this.updateBy +
            ", updateDt=" + this.updateDt +
            ", agentGrpInd=" + this.agentGrpInd +
            ", flagent_Id=" + this.flagent_Id +
            ", valid_Cd=" + this.valid_Cd +
            ", dxFlow_Id=" + this.dxFlow_Id +
            ", disableFlg=" + this.disableFlg +
            ", attachmentFiles=" + this.attachmentFiles +
            ", flagentNm=" + this.flagentNm +
            ", msgValid_Cd=" + this.msgValid_Cd +
            ", email_To_Valid_Cd=" + this.email_To_Valid_Cd +
            ", email_Cc_Valid_Cd=" + this.email_Cc_Valid_Cd +
            ", subject_Valid_Cd=" + this.subject_Valid_Cd +
            ",retryEnabled =" + this.retryEnabled +
            ",numOfRetryAttempts = "+ this.numOfRetryAttempts +
            ",retryWaitTime ="+ this.retryWaitTime;
            if (isNotCompare) {
                str += ''
            }
            str += ']';
    
            return str;
        }
    }
    
